import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

/** Small centered title bar with a back control for detail pages (spec §6.5). */
export function SectionHeader({ title, backTo = "/" }: { title: string; backTo?: string }) {
  return (
    <header className="section-header">
      <Link to={backTo} className="back-button" aria-label="Back">
        <ChevronLeft size={20} strokeWidth={2.5} />
      </Link>
      <h1 className="section-header-title">{title}</h1>
      <span className="section-header-spacer" />
    </header>
  );
}
